export const PROFILE_ROUTE_NAME = 'profile'

export const GO_TO_PROFILE_LABEL = 'Go to profile'
